/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { CheckCircle } from "@mui/icons-material"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useHistory } from "react-router-dom"
import { paths, VerticaisManager } from "src/components/vendas/VerticaisManager"
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api"
import { ProjetosProvider } from "src/providers/ProjetosProvider"
import theme from "src/theme/light"
import { NOVO_PROJETO_ENGENHARIA, POTENCIA_MINIMA_ENGENHARIA, POTENCIA_MINIMA_VERTICAL } from "../constants"
import { ComponenteCalcular, ListagemItem, Projeto, ProjetoCalcular, ProjetoServico, ResultadoCalculos } from "../types"
import { Acessorios } from "./containers/Acessorios"
import { Estruturas } from "./containers/Estruturas"
import { Finalizacao } from "./containers/Finalizacao"
import { Gerador } from "./containers/Gerador"
import { formatarComponentesCalcular } from "../utils/formatarComponentesCalcular"
import { salvarProjeto } from "../utils/salvarProjeto"
import { setVendedorInternoModalStatus } from "src/store/vendas/projetos/actions"
import { projetoSalvoComSucessoDialog } from "../utils/projetoSalvoComSucessoDialog"
import { redirecionarParaProjetosEspeciais } from "../utils/redirecionarParaProjetosEspeciais"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { ModalDetalhes as ModalDetalhesComponentes }  from '../../componentes/ModalDetalhes'
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";
import { useObservable } from "src/framework/store/storeUtil";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import { useProjetoPersonalizadoHibridoStore } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.store";

export type TabName = 'gerador' | 'estruturas' | 'acessorios' | 'finalizacao'

interface TabProps {
  name: TabName;
  label: string;
  done: boolean;
  disabled: boolean;
}

export interface CalcularType {
  valorServico?: number;
  tipoServico?: ProjetoServico;
}

const useStyles = makeStyles({
  tabIcon: {
    marginRight: 8,
    fontSize: 22
  }
})

const projetosProvider = new ProjetosProvider();
const manager = new VerticaisManager(paths, api, apiNoLoading);

const ProjetoPersonalizadoHibrido = () => {
  const classes = useStyles()
  const history = useHistory();

  const projetoState = useProjetoPersonalizadoHibridoStore(store => store.state.data)
  const { changeValue, changeModal, reset } = useProjetoPersonalizadoHibridoStore(store => store.actions)
  const validations = useProjetoPersonalizadoHibridoStore(store => store.state.validations)
  const modalComponentesDetalhesData = useProjetoPersonalizadoHibridoStore(store => store.state.modals.detalhesComponenteId)

  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const permissoes = PermissionUtil.getPermissions();
  const [tab, setTab] = useState<TabName>('gerador')
  const projeto = projetoState

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const moduloSelecionado = useMemo(()=>{
    return projetoState.modulosList?.find(item => item.selecionado) || null
  },[projetoState.modulosList])

  const acessoriosAdicionados = useMemo(()=>{
    return projetoState.acessorios?.filter(item => item.quantidade > 0) || []
  },[projetoState.acessorios])

  const estruturasAdicionadas = useMemo(()=>{
    const estruturas: ListagemItem[] = []
    const selected = projetoState.estruturasSelecionadas?.filter(item => {
      const total = item.items.reduce((acc, curr) => acc + curr.quantidade, 0)
      if (total > 0) return true;
      return false;
    }) || []
    selected.forEach(grupo => {
      grupo.items.forEach(item => {
        if (item.quantidade > 0) {
          estruturas.push(item)
        }
      })
    })
    return estruturas;
  },[projetoState.estruturasSelecionadas])

  const inversoresAdicionados = useMemo(()=>{
    return projetoState.inversoresList?.filter(item => item.quantidade > 0) || []
  },[projetoState.inversoresList])

  const calcular = useCallback(async({ valorServico }: CalcularType = {})=>{
    const componentes: ComponenteCalcular[] = []

    if (moduloSelecionado) {
      componentes.push(...formatarComponentesCalcular([moduloSelecionado]))
    }

    if (estruturasAdicionadas.length) {
      componentes.push(...formatarComponentesCalcular(estruturasAdicionadas))
    }

    if (acessoriosAdicionados.length) {
      componentes.push(...formatarComponentesCalcular(acessoriosAdicionados))
    }

    if(inversoresAdicionados?.length){
      componentes.push(...formatarComponentesCalcular(inversoresAdicionados))
    }

    const getValorServico = () => {
      if (!projetoState.recebe_servico) return 0;
      if (projetoState.tipo_proposta?.value === 'gerador-sem-instalacao') return 0;
      return Number(valorServico ?? projetoState.valor_servico ?? 0)
    } 

    const recalcular = projetosProvider.confereRecalcular(componentes, projetoState);

    const regioesIds = projetoState.regioes.map(item => item.id)

    const payload: ProjetoCalcular = {
      componentes,
      estado_id: projetoState?.estado?.id || '',
      servicos: {
        tipo: getValorServico() ? 'revenda' : null,
        valor: getValorServico(),
      },
      regioes: regioesIds,
      segmento: projetoState.segmento,
      projeto_id: projetoState.clonar_projeto ? undefined : (projetoState.id || undefined),
      distribuidor_id: projetoState.distribuidor?.id || undefined,
      revenda_id: projetoState.revenda?.id || undefined,
      recalcular: recalcular,
    }

    const responseCalcular: IDataResponse<ResultadoCalculos> = await projetosProvider.calcular(payload, true)
    changeValue({ valor_servico_pis_cofins: responseCalcular.data?.servicos?.valor_com_pis_cofins || 0, resultado_calculos: responseCalcular.data })
  },[projetoState.revenda?.id, projetoState.distribuidor?.id, projetoState?.id, projetoState?.estado?.id, projetoState.tipo_proposta?.value, projetoState.recebe_servico, acessoriosAdicionados, projetoState.valor_servico, projetoState.regioes, moduloSelecionado, projetoState.tipo, estruturasAdicionadas, inversoresAdicionados])
  
  const handleNextTab = useCallback(async(tabName: TabName)=>{
    setTab(tabName)
    if (tabName === 'finalizacao') {
      calcular()
    }
  },[calcular])

  const afterSave = useCallback((response: IDataResponse) => {
    projetoSalvoComSucessoDialog(response?.data?.[0]?.codigo_venda, history, {
      tipoProjeto: 'personalizado_hibrido',
      onClose: reset,
      onConfirmation: reset
    })
  }, [history, projetoState?.tipo])

  const save = useCallback((updatedProjetoState: Partial<Projeto> = {})=>{
    const payload = {
      ...projetoState,
      ...updatedProjetoState,
    }

    salvarProjeto(manager, projetoState.id, payload, authUser, projetoState?.clonar_projeto, true).then((response: IDataResponse) => {
      const allowedStatusCode = [STATUS_CODE.OK, STATUS_CODE.CREATED]
      if(allowedStatusCode.includes(response.statusCode)) {
        afterSave(response)
      }
    })
  },[afterSave, projetoState])

  const beforeSave = useCallback(() => {
    const withPermission = PermissionUtil.can(PermissionUtil.PERMISSION_VENDEDORES_LISTAGEM, permissoes);
    if (withPermission && (!projetoState.isEdit || projetoState?.alterou_segmento || projetoState.clonar_projeto)) {
      setVendedorInternoModalStatus(true, (vendedor) => {
        save({ vendedor_interno: vendedor })
      })
    } else {
      save()
    }
  },[projetoState, save, permissoes])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = projetoState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[projetoState?.modulosList]);

  const potenciaInvalida = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_ENGENHARIA;
  },[potenciaTotal]);

  const alertaProjetoPotencia = useCallback(async() => {
    if (potenciaInvalida) {
      redirecionarParaProjetosEspeciais({
        onNegation: () => {
          changeValue({...projetoState, ...NOVO_PROJETO_ENGENHARIA })
          history.push('/projetos/verticais/novo',{ allowAccess: true })
        },
      });
    }
  },[potenciaInvalida])

  const handleSave = useCallback(async() => {
    if (potenciaInvalida) {
      alertaProjetoPotencia();
      return;
    }

    beforeSave();
  },[beforeSave, projetoState, potenciaInvalida])

  const alterarCodigoVenda = useCallback((codigoVenda, segmento) => {
    const vertical = segmento?.includes('vertical');
    if (vertical && !codigoVenda?.includes('PROV')) {
      return codigoVenda?.replace('HIBRI', 'PROV');
    } else if (!vertical && !codigoVenda?.includes('HIBRI')) {
      return codigoVenda?.replace('PROV', 'HIBRI');
    }
    return codigoVenda;
  }, []);


  useEffect(() => {
    const recalcular = async () => {
      let segmentoProjeto = projeto.segmento;
      if (potenciaTotal > POTENCIA_MINIMA_VERTICAL) {
        segmentoProjeto = 'vertical_ongrid';
      } else {
        segmentoProjeto = 'distribuicao_ongrid';
      }
      
      const alterouSegmento = projetoState.segmento !== segmentoProjeto;
      if (alterouSegmento) {
        const codigoVenda = alterarCodigoVenda(projetoState.codigo_venda, segmentoProjeto);

        changeValue({
          segmento: segmentoProjeto,
          codigo_venda: codigoVenda,
          alterou_segmento: alterouSegmento,
          auto_comissao: true,
          "@proposta_atualizada": true
        });
      }
    }

    const alterouCodigoVenda = projetoState.codigo_venda && projetoState.codigo_venda !== projeto.codigo_venda;
    if ((potenciaTotal && Number(potenciaTotal) !== Number(projeto?.potencia)) || alterouCodigoVenda) {
      recalcular();
    }
  }, [potenciaTotal, projeto, projetoState.codigo_venda])


  const tabs = useMemo<TabProps[]>(() => {
    const geradorDone = !!validations?.gerador;
    const estruturasDone = !!(geradorDone && validations?.estruturas);
    const acessoriosDone = !!(geradorDone && validations?.acessorios);
    const finalizacaoDone = !!(geradorDone && validations?.finalizacao);

    return [
      {
        name: 'gerador',
        label: 'Gerador',
        done: geradorDone || false,
        disabled: false
      },
      { 
        name: 'estruturas',
        label: 'Estruturas',
        done: estruturasDone || false,
        disabled: !estruturasDone
      },
      {
        name: 'acessorios',
        label: 'Acessórios',
        done: acessoriosDone,
        disabled: !acessoriosDone
      },
      {
        name: 'finalizacao',
        label: 'Finalização',
        done: finalizacaoDone,
        disabled: !finalizacaoDone
      },
    ]
  },[validations])
  return (
    <>
      <Paper elevation={0} className="tab-header">
        <TabControl
          indicatorColor="primary" 
          onChangeTab={() => {}}
          currentTabName={tab}
        >
          {tabs.map(item => (
            <TabContent
              disabled
              name={item.name}
              visible={true}
              label={
                <Box display={isMobile ? "none" : "flex"} justifyContent={"center"} alignItems="center">
                  <CheckCircle htmlColor={item.done ? theme.palette.primary.dark : 'unset'} className={classes.tabIcon} />
                  <span style={{ color: theme.palette.text.secondary }}>{item.label}</span>     
                </Box>
              }>

              {item.name === 'gerador' && tab === 'gerador' && (
                <Gerador
                  onClickBack={() => {
                    if (projetoState.clonar_projeto) {
                      history.push(`/projetos/${projetoState.id}/personalizado_hibrido/clonar`, { noReset: true })
                      return
                    }

                    if (projetoState.isEdit) {
                      history.push(`/projetos/${projetoState.id}/personalizado_hibrido/edicao`, { noReset: true })
                      return
                    }

                    history.push('/projetos?tipo=personalizado_hibrido', { noReset: true })
                  }} 
                  onClickNext={() => handleNextTab('estruturas')}
                />
              )}

              {item.name === 'estruturas' && tab === 'estruturas' && (
                <Estruturas
                  tab={tab}
                  onClickBack={() => handleNextTab('gerador')} 
                  onClickNext={() => handleNextTab('acessorios')} 
                />
              )}

              {item.name === 'acessorios' && tab === 'acessorios' && (
                <Acessorios
                  onClickBack={() => handleNextTab('estruturas')} 
                  onClickNext={() => handleNextTab('finalizacao')} 
                />
              )}

              {item.name === 'finalizacao' && tab === 'finalizacao' && (
                <Finalizacao
                  calcular={calcular}
                  onClickBack={() => handleNextTab('acessorios')}
                  onClickNext={handleSave}
                />
              )}
            </TabContent>
          ))}
        </TabControl>
      </Paper>

      {!!modalComponentesDetalhesData && (
        <ModalDetalhesComponentes 
          open={!!modalComponentesDetalhesData}
          componentId={modalComponentesDetalhesData}
          setOpenModal={(openStatus: any) => {
            if (!openStatus) changeModal({ detalhesComponenteId: null })
          }}
        />
      )}
    </>
  )
}

export { ProjetoPersonalizadoHibrido }
